import { useTranslation } from 'react-i18next'
import { StyledInput, StyledInputContainer, StyledSearchIcon } from './styles'
import { useLanguage } from '@/utils/hooks/useLanguage'

type SearchInputProps = {
  setSearch: (search: string) => void
}

const SearchInput = ({ setSearch }: SearchInputProps) => {
  const { t } = useTranslation()
  const locale = useLanguage()

  return (
    <StyledInputContainer locale={locale}>
      <StyledSearchIcon />
      <StyledInput
        placeholder={t('documentsPage.searchPlaceholder')}
        onChange={(e) => setSearch(e.target.value)}
      />
    </StyledInputContainer>
  )
}

export default SearchInput
